import { PatchEfemPeripheralBodySchema } from '../../efem-wafer-imaging.schemas.js';
import { ClaimOrderResponseSchema } from '../../schemas.js';
import { ClaimOrderRequestSchema, PendingShipmentsResponseSchema, TenantDeviceDetailResponseSchema, TenantDeviceListQuerySchema, TenantDeviceListResponseSchema, TenantUnclaimedDevicesResponseSchema, } from '../../schemas/tenant-devices.schemas.js';
import { DeviceSerialNumberParamSchema } from '../../schemas/params.js';
/** REST contract for `insight-api/src/routes/tenant/tenant-devices.routes.ts`. */
export const tenantDevicesContract = {
    list: {
        method: 'GET',
        path: '/tenant/devices',
        query: TenantDeviceListQuerySchema,
        response: TenantDeviceListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list tenant devices',
    },
    listUnclaimed: {
        method: 'GET',
        path: '/tenant/devices/unclaimed',
        response: TenantUnclaimedDevicesResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to list unclaimed tenant devices',
    },
    getPendingShipments: {
        method: 'GET',
        path: '/tenant/devices/pending-shipments',
        response: PendingShipmentsResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get pending shipments',
    },
    getBySerial: {
        method: 'GET',
        path: '/tenant/devices/:serialNumber',
        pathParams: DeviceSerialNumberParamSchema,
        response: TenantDeviceDetailResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get tenant device',
    },
    claimOrder: {
        method: 'POST',
        path: '/tenant/devices/claim',
        body: ClaimOrderRequestSchema,
        response: ClaimOrderResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to claim order',
    },
    patchEfemPeripheral: {
        method: 'PATCH',
        path: '/tenant/devices/:serialNumber/efem-peripheral',
        pathParams: DeviceSerialNumberParamSchema,
        body: PatchEfemPeripheralBodySchema,
        response: TenantDeviceDetailResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update EFEM peripheral binding',
    },
};
//# sourceMappingURL=tenant-devices.contract.js.map